"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _themeInjector = _interopRequireDefault(require("../../themeTools/build/themeInjector"));

require("./fonts.scss");

var _CxTheme = _interopRequireDefault(require("./Cx.theme.js"));

/* eslint-disable */
// Do not edit this generated file.  If this file needs changes then the createThemeImporterAndLoader script should be modified
// This file is generated by the createThemeLoader script when the createThemes, or createTheme script is run
var CxThemeLoader = function CxThemeLoader(setIsThemeLoaded, loadCxLast) {
  (0, _themeInjector.default)("Cx", (0, _CxTheme.default)(), loadCxLast);
  setIsThemeLoaded(true);
};

var _default = CxThemeLoader;
exports.default = _default;